"use strict";

exports.__esModule = true;
exports.default = baseIteratee;
var _identity = _interopRequireDefault(require("./identity.js"));
var _isFunction = _interopRequireDefault(require("./isFunction.js"));
var _isObject = _interopRequireDefault(require("./isObject.js"));
var _isArray = _interopRequireDefault(require("./isArray.js"));
var _matcher = _interopRequireDefault(require("./matcher.js"));
var _property = _interopRequireDefault(require("./property.js"));
var _optimizeCb = _interopRequireDefault(require("./_optimizeCb.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// An internal function to generate callbacks that can be applied to each
// element in a collection, returning the desired result — either `_.identity`,
// an arbitrary callback, a property matcher, or a property accessor.
function baseIteratee(value, context, argCount) {
  if (value == null) return _identity.default;
  if ((0, _isFunction.default)(value)) return (0, _optimizeCb.default)(value, context, argCount);
  if ((0, _isObject.default)(value) && !(0, _isArray.default)(value)) return (0, _matcher.default)(value);
  return (0, _property.default)(value);
}